/*
 * Developed for EPSON AMERICA INC. by Softeq Development Corporation
 * http://www.softeq.com
 */

import _get from 'lodash/get'
import { USER_LOGOUT_ACTION } from 'constants/user'
import { API_TYPES, NOT_SECURE_API_TYPES } from 'constants/apiTypes'
import { getCountryByCountryIdState } from 'api/client/actions/country'
import { getAppConfig, getRecaptchaWhiteListConfig } from 'api/client/actions/settings'
import { handlePromiseActions } from 'redux-app/utils/reducer'
import { loadingWrapper } from 'redux-app/utils/loadingWrapper'

const ACTION_HANDLERS = {
  [getCountryByCountryIdState.toString()]: loadingWrapper(API_TYPES.states, [
    [],
    (state, action) => action.payload.result,
    () => [],
  ]),
  [getAppConfig.toString()]: loadingWrapper(API_TYPES.appConfig, [
    null,
    (state, action) => action.payload.result,
    null,
  ]),
  [getRecaptchaWhiteListConfig.toString()]: loadingWrapper(API_TYPES.recaptchaWhiteList, [
    null,
    (state, action) => action.payload.result,
    null,
  ]),
  [USER_LOGOUT_ACTION]: (state) => NOT_SECURE_API_TYPES.reduce((acc, apiType) => ({
    ...acc,
    [apiType]: _get(state, apiType),
  }), {}),
}

const initialState = {}

export default handlePromiseActions(ACTION_HANDLERS, initialState)
